import Accordion from '@ui/accordion/Accordion';
import AccordionItem from '@ui/accordion/AccordionItem';
import Button from '@ui/button/Button';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import api from '@utils/api';
import useBreakpoint from '@utils/useBreakpoint';
import useQueryStringBoolean from '@utils/useQueryStringBoolean';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SuggestedCountryModal from './SuggestedCountryModal';
import classNames from 'classnames';
const CountryModal = (props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useQueryStringBoolean('countryselector');
    const [data, setData] = useState();
    const [confirmed, setConfirmed] = useState();
    const [requireconfirm, setRequireconfirm] = useState();
    const currentBreakpoint = useBreakpoint();
    useEffect(() => {
        if (open) {
            api.getMiniCart().then((cart) => {
                setRequireconfirm(cart.isExchange || false);
                api.countrySelectorJson().then((data) => {
                    setData(data);
                });
            });
        }
    }, [open]);
    const countries = (countries, region) => countries === null || countries === void 0 ? void 0 : countries.map((country) => (React.createElement("li", { key: country.link },
        React.createElement("a", { href: country.link, "data-analytics-country": country.countryCode, onClick: () => {
                analytics.countryselectorClick(region, country.name.toLowerCase());
            } },
            React.createElement("span", { className: "countryname" }, country.name),
            country.shoppable && React.createElement("span", { className: "icon--bag", "aria-label": t('changecountry.shoppable.aria') }),
            window.country === country.countryCode && React.createElement("span", { className: "icon--checkmark", "aria-label": t('changecountry.current.aria') })))));
    const desktopLayput = () => (React.createElement("div", { className: "countryselector-wrapper mt-32" },
        React.createElement("div", { className: "row" },
            data.EUROPE && (React.createElement("div", { className: "col-md-6" },
                React.createElement("div", { className: "continent" },
                    React.createElement("h5", { className: "card-header" }, "EUROPE"),
                    React.createElement("div", { className: "accordion__panel" },
                        React.createElement("ol", null, countries(data.EUROPE, 'europe')))))),
            data.AMERICAS && (React.createElement("div", { className: "col-md-3" },
                React.createElement("div", { className: "continent" },
                    React.createElement("h5", { className: "card-header" }, "AMERICAS"),
                    React.createElement("div", { className: "accordion__panel" },
                        React.createElement("ol", null, countries(data.AMERICAS, 'americas')))))),
            React.createElement("div", { className: "col-md-3" },
                data.ASIA && (React.createElement("div", { className: "continent" },
                    React.createElement("h5", { className: "card-header" }, "ASIA"),
                    React.createElement("div", { className: "accordion__panel" },
                        React.createElement("ol", null, countries(data.ASIA, 'asia'))))),
                data.OCEANIA && (React.createElement("div", { className: "continent mt-32" },
                    React.createElement("h5", { className: "card-header" }, "OCEANIA"),
                    React.createElement("div", { className: "accordion__panel" },
                        React.createElement("ol", null, countries(data.OCEANIA, 'oceania')))))))));
    const confirmationDialog = () => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row countryselector-modal" },
            React.createElement("div", { className: "col-12" },
                React.createElement("div", { className: "countryselector-modal__description" }, t('exchange.changecountrywarning')),
                React.createElement("div", { className: "countryselector-modal__description" }, t('checkout.shipping.changecountryproceed')))),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-6 col-md-3" },
                React.createElement(Button, { type: "button", cls: ['button--secondary'], onClick: () => {
                        setOpen(false);
                    } }, t('label.no'))),
            React.createElement("div", { className: "col-6 col-md-3" },
                React.createElement(Button, { type: "button", cls: ['button--primary'], onClick: () => {
                        setConfirmed(true);
                    } }, t('label.yes'))))));
    const mobileLayout = () => (React.createElement(Accordion, null,
        data.EUROPE && (React.createElement(AccordionItem, { title: "EUROPE", accordionId: "region_europe" },
            React.createElement("ol", null, countries(data.EUROPE, 'europe')))),
        data.AMERICAS && (React.createElement(AccordionItem, { title: "AMERICAS", accordionId: "region_americas" },
            React.createElement("ol", null, countries(data.AMERICAS, 'americas')))),
        data.ASIA && (React.createElement(AccordionItem, { title: "ASIA", accordionId: "region_asia" },
            React.createElement("ol", null, countries(data.ASIA, 'asia')))),
        data.OCEANIA && (React.createElement(AccordionItem, { title: "OCEANIA", accordionId: "region_oceania" },
            React.createElement("ol", null, countries(data.OCEANIA, 'oceania'))))));
    const modal = () => (React.createElement(ModalDialog, { isOpen: open, onRequestClose: () => {
            setOpen(false);
            analytics.countryselectorClose();
        }, hasDivisor: !requireconfirm || confirmed, contentLabel: t('modal.country.title'), subtitle: requireconfirm && !confirmed ? '' : t('modal.country.description'), className: "country-modal" }, requireconfirm && !confirmed ? React.createElement(React.Fragment, null, confirmationDialog()) : React.createElement(React.Fragment, null, currentBreakpoint >= window.mqObj['md'] ? desktopLayput() : mobileLayout())));
    if (props.children) {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "countryselector" },
                React.createElement("button", { type: "button", onClick: () => {
                        setOpen(true);
                    }, dangerouslySetInnerHTML: { __html: props.children } })),
            data && modal()));
    }
    if (props.fromBookAnAppointment) {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "countryselector" },
                t('bookanappointment.currentlocation', { country: window.countryname }),
                ' ',
                React.createElement("button", { className: "link-button", type: "button", onClick: () => {
                        setOpen(true);
                    } }, t('bookanappointment.differentlocation'))),
            data && modal()));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: classNames('footer-menu__menuitem', { container: props.contained }), onClick: (e) => {
                e.preventDefault();
                setOpen(true);
            }, "aria-haspopup": "dialog" },
            React.createElement("span", { className: "footer-menu__menuitem__item" }, t('footer.item.country')),
            React.createElement("span", { className: "footer-menu__menuitem__current" }, window.countryname)),
        data && modal(),
        !props.editMode && React.createElement(SuggestedCountryModal, { setCountrySelectorOpen: setOpen })));
};
export default CountryModal;
